import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { SecondaryHeaderLoader } from 'src/domains/layouts/shared/loaders';

export const RaceSliderItemLoaderWrapper = styled('div', { label: 'RaceSliderItemLoaderWrapper' })`
    flex: 0 0 300px;
    user-select: none;
    width: 300px;
`;

export const RaceSliderHeaderLoader = styled(SecondaryHeaderLoader, { label: 'RaceSliderHeaderLoader' })`
    border-radius: 8px 8px 0 0;
`;

export const RaceSliderListItem = withConfig(theme => styled('li', { label: 'RaceSliderListItem' })`
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
    display: flex;
    flex-flow: row nowrap;
    height: 48px;
    justify-content: space-between;
    &:last-of-type {
        border-radius: 0 0 8px 8px;
        height: 40px;
    }
`);

